import classes from "../../Table/Table.module.css";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authContext from "../../../../AuthContext/authContext";
import appActions from "../../../../ReduxStore/appDataSlice";
import Home from "../../Common/Home/Home";
import BuildingTable from "../BuildingTable/BuildingTable";
import ConfirmModal from "../../Common/ConfirmModal/ConfirmModal";
import AssignPassesModal from "../../Company/LocationWrapper/AssignPassesModal";
import { toast } from "react-toastify";
const base_url = process.env.REACT_APP_BASE_URL;
const BuildingWrapper = () => {
  const activeBuilding = useSelector((state) => state.appData.activeBuilding);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(authContext);
  const token = ctx.token;
  const [isLoading, setIsloading] = useState(false);
  const [buildingToDelete, setBuildingToDelete] = useState({});
  const [ppoEntries, setPpoEntries] = useState({});

  const [assignPassesModal, setAssignPassesModal] = useState({
    isOpen: false,
    locationId: null,
    locationName: '',
    currentPasses: 0,
    maxPasses: 1000,
    totalPassesAllocatedToTheCompany: 0,
    isLoading: false,
    payload: { passes: 0, action: '' }
  });

  const handleEdit = (id) => {
    dispatch(appActions.setActiveEditLocationId(id));
    localStorage.setItem("activeEditLocationId", id);

    dispatch(appActions.setActiveEditType("Company"));
    localStorage.setItem("activeEditType", "Company");
    navigate("/editLocation");
  };

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: "DELETE",
      url: `${base_url}/company/building/company/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        // console.log(err);
        setIsloading(false);
      });
  };
  useEffect(() => {
    // setIsloading(true);
    fetchCompanyDetails();
    // fetchCompanyDetails is now defined above and called from useEffect
  }, []);

  const fetchCompanyDetails = async () => {
    setIsloading(true);
    try {
      const reqObj = {
        method: "GET",
        url: `${base_url}/company/details/${activeBuilding._id}`,
        headers: {
          "Content-Type": "application/javascript",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios(reqObj);
      // setShowEmployeeDirectory(response.data.employeeDirectory);
      
      // Optimized PPO data handling
      const ppoData = response.data.ppoData;
      if (Array.isArray(ppoData)) {
        // Find first active PPO or use empty object
        let activePpo = {};
        for (let i = 0; i < ppoData.length; i++) {
          if (ppoData[i]?.isActive === true) {
            activePpo = ppoData[i];
            break; // Exit loop as soon as we find the first active PPO
          }
        }
        setPpoEntries(activePpo);
      } else {
        setPpoEntries({});
      }
    } catch (err) {
      console.error("Error fetching company details:", err);
    } finally {
      setIsloading(false);
    }
  };
console.log(ppoEntries);
  const columns = [
    {
      name: "S. No.",
      cell: (row, index) => index + 1,
    },
    {
      name: "Company Name",
      selector: (row) => row.location,
      sortable: true,
    },
    {
      name: "Company Manager Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Company Manager Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Company Manager Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    ppoEntries?.ppoPassCount > 0 && {
      name: "Passes",
      selector: (row) => {
        return `${parseInt(row.passes-row.availablePasses) || 0}/${row.passes || 0}`;
      },
      sortable: true,
      conditionalCellStyles: [
        {
          when: row => row.passes && row.availablePasses,
          style: {
            fontWeight: 'bold',
            color: '#333'
          }
        }
      ]
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <div className={classes.icons}>
            {/* <img src={require("../../../../assets/img/admin-images/eye.png")} /> */}
            <img
              style={{ cursor: "pointer" }}
              src={require("../../../../assets/img/admin-images/edit_thin.png")}
              onClick={() => handleEdit(row._id)}
            />
            {/*<img
              style={{ cursor: "pointer" }}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              src={require("../../../../assets/img/admin-images/delete.png")}
              // onClick={() => handleDelete(row._id)}
              onClick={() =>
                setBuildingToDelete({ id: row._id, name: row.location })
              }
            />*/}
          </div>
          {ppoEntries.ppoPassCount > 0 && (
              <div className={classes.iconWrapper}>
                <button 
                  onClick={() => {
                    setAssignPassesModal({
                      isOpen: true,
                      locationId: row._id,
                      locationName: row.location,
                      currentPasses: row.passes - row.availablePasses || 0,
                      maxPasses: row.passes,
                      totalPassesAllocatedToTheCompany: parseInt(ppoEntries.availablePassCount) || 0,
                      isLoading: false
                    });
                  }}
                  title="Manage Pass"
                  className="bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 font-medium py-1 px-1 rounded-md text-sm transition-colors duration-200"
                >
                  Manage Pass
                </button>
              </div>
            )}
        </>
      ),
    },
  ];
  const options = {
    // title: activeCompany.name,
    title: "Building",
    showCsvExport: false,
    showDownload: false,
    showExport: false,
    showLocation: false,
    showSms: true,
    showAddNew: true,
    showFirstHr: false,
    showSecondHr: true,
    showActions: true,
    type: "Building",
    columns: columns,
    apiUrl: `${base_url}/company/building/company/list`,
    companyId: activeBuilding._id,
    locationId: activeLocation._id,
    showVisitor: true,
  };

  return (
    <>
      <Home
        propComponent={
          <BuildingTable options={options} isLoading={isLoading} />
        }
      />
      <ConfirmModal
        handleDelete={handleDelete}
        id={buildingToDelete.id}
        msg={`Are you sure you want to delete ${buildingToDelete.name}?`}
      />

<AssignPassesModal
        key={assignPassesModal.locationId || 'modal'}
        isOpen={assignPassesModal.isOpen}
        onClose={() => setAssignPassesModal({
          isOpen: false,
          locationId: null,
          locationName: '',
          currentPasses: 0,
          maxPasses: 1000,
          totalPassesAllocatedToTheCompany: 0,
          isLoading: false,
          payload: { passes: 0, action: '' }
        })}
        onAssignPasses={async (payload) => {
          try {
            setAssignPassesModal(prev => ({ ...prev, isLoading: true }));

            const response = await axios.post(
              `${base_url}/company/assign-passes/${activeBuilding._id}`,
              { passes:payload.passes, locationId: assignPassesModal.locationId, action: payload.action,userType: 'company' },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ctx.token}`
                }
              }
            );
            toast.success('Pass balance updated successfully');
            setAssignPassesModal({
              isOpen: false,
              locationId: null,
              locationName: '',
              currentPasses: 0,
              maxPasses: 1000,
              totalPassesAllocatedToTheCompany: 0,
              isLoading: false,
              payload: { passes: 0, action: '' }
            })
            fetchCompanyDetails();
          } catch (error) {
            console.error('Error assigning passes:', error);
            toast.error(error.response?.data?.message || 'Failed to assign passes');
          } finally {
            setAssignPassesModal(prev => ({ ...prev, isLoading: false }));
          }
        }}
        locationName={assignPassesModal.locationName}
        currentPasses={assignPassesModal.currentPasses}
        maxPasses={assignPassesModal.maxPasses}
        totalPassesAllocatedToTheCompany={assignPassesModal.totalPassesAllocatedToTheCompany}
        isLoading={assignPassesModal.isLoading}
      />
    </>
  );
};

export default BuildingWrapper;
